import React from "react";
import './Blog.css';

function Blog({ borderColor = "#c9d7ff" }) {
  const posts = [
    {
      id: 1,
      date: '05 June 2025',
      tag: 'Award',
      title: 'Chambers USA 2025: 121 Kirkland Practice Areas and 294 Attorneys Ranked',
      cta: 'Watch Video',
      image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=1600&auto=format&fit=crop',
      link: '/blog/chambers-usa-2025'
    },
    {
      id: 2,
      date: '09 April 2025',
      tag: 'Award',
      title: 'Kirkland Earns Spot on BTI\'s 2025 “Best of the Best” Law Firms List',
      image: 'https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?q=80&w=1600&auto=format&fit=crop',
      link: '/blog/bti-best-firms-2025'
    },
    {
      id: 3,
      date: '13 February 2025',
      tag: 'Award',
      title: 'Chambers Global 2025: 82 Kirkland Practice Areas and 145 Attorneys Ranked',
      image: 'https://images.unsplash.com/photo-1488197047962-b48492212cda?q=80&w=1600&auto=format&fit=crop',
      link: '/blog/chambers-global-2025'
    },
    {
      id: 4,
      date: '11 June 2025',
      tag: 'Award',
      title: 'The Legal 500 U.S. 2025: 64 Kirkland Practice Areas and 280 Attorneys Recognized',
      featured: true,
      cta: 'Watch Video',
      heroImage: 'https://images.unsplash.com/photo-1534258936925-c58bed479fcb?q=80&w=1920&auto=format&fit=crop',
      link: '/blog/legal500-us-2025'
    },
    {
      id: 5,
      date: '25 June 2024',
      tag: 'Award',
      title: "Kirkland Recognized in Chambers' 2024 Crisis & Risk Management Guide",
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=1600&auto=format&fit=crop',
      link: '/blog/crisis-risk-2024'
    },
  ];

  return (
    <section
      className="blog-section"
      style={{ '--card-border': borderColor }}
    >
      <aside className="about-left" style={{ marginLeft: "-110px" }}>
        <h2>บทความ</h2>
        <span className="left-underline" aria-hidden="true"></span>
      </aside>

      <div className="blog-grid">
        {posts.map(post => {
          const perCardStyle = {
            ...(post.borderColor ? { '--card-border': post.borderColor } : {}),
            ...(post.featured && post.heroImage ? { '--hero-image': `url(${post.heroImage})` } : {})
          };

          return post.featured ? (
            <a
              key={post.id}
              href={post.link}
              className="blog-card blog-card--large"
              style={perCardStyle}
            >
              <div className="hero-overlay">
                <div className="meta">{post.date} &nbsp; - &nbsp; {post.tag}</div>
                <h3 className="hero-title">{post.title}</h3>
                {post.cta && <button className="cta">{post.cta} ►</button>}
              </div>
            </a>
          ) : (
            <a
              key={post.id}
              href={post.link}
              className="blog-card"
              style={perCardStyle}
            >
              {post.image && (
                <div
                  className="thumb"
                  style={{ backgroundImage: `url(${post.image})` }}
                  aria-label={post.title}
                />
              )}
              <div className="meta">{post.date} &nbsp; - &nbsp; {post.tag}</div>
              <h4 className="card-title">{post.title}</h4>
              {post.cta && <button className="card-cta">{post.cta} ►</button>}
            </a>
          );
        })}
      </div>

      <div className="more-wrap">
        <button className="more-btn">+ More</button>
      </div>
    </section>
  );
}

export default Blog;
